if (!customElements.get('natunora-bottom-faq')) {
  customElements.define('natunora-bottom-faq', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const animations = new Map();
      const finish = () => {
        animations.forEach(animation => animation.cancel());
        animations.clear();
      };
      this.finish = finish;
      window.addEventListener('resize', finish, options);
      motion.addEventListener('change', finish, options);
      const toggle = (button, open) => {
        const answer = this.querySelector('[id="' + button.getAttribute('aria-controls') + '"]');
        if (!answer) return;
        const start = answer.getBoundingClientRect().height;
        animations.get(answer)?.cancel();
        animations.delete(answer);
        button.setAttribute('aria-expanded', String(open));
        button.closest('.n-offer-faq__item').dataset.open = String(open);
        answer.inert = !open;
        const css = getComputedStyle(answer);
        const time = css.getPropertyValue('--natunora-motion-duration').trim();
        const duration = motion.matches ? 0 : parseFloat(time) * (time.endsWith('ms') ? 1 : 1000);
        if (!duration || !answer.animate) return;
        const end = answer.getBoundingClientRect().height;
        const animation = answer.animate([{ height: `${start}px` }, { height: `${end}px` }], {
          duration, easing: css.getPropertyValue('--natunora-motion-easing').trim(), fill: 'both'
        });
        animations.set(answer, animation);
        animation.onfinish = () => {
          if (animations.get(answer) !== animation) return;
          animation.cancel();
          animations.delete(answer);
        };
      };
      const track = (name) => {
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') {
            window.clarity('event', name);
          }
        } catch (_) {}
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-faq-question]');
        if (button && this.contains(button)) {
          const open = button.getAttribute('aria-expanded') !== 'true';
          if (open) this.querySelectorAll('[data-faq-question][aria-expanded="true"]').forEach(peer => {
            if (peer !== button) toggle(peer, false);
          });
          toggle(button, open);
          if (open) track('natunora_bottom_faq_open_' + button.dataset.faqQuestion);
        } else if (event.target.closest('[data-faq-support]')) {
          track('natunora_bottom_faq_support_click');
        }
      }, { signal: this.abort.signal });
      this.addEventListener('auxclick', (event) => {
        if (event.button === 1 && event.target.closest('[data-faq-support]')) track('natunora_bottom_faq_support_click');
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.finish?.(); }
  });
}
